var path = 'app/scripts/modules/kubernetes/src/pipeline/stages/runJob/runJobLogs.html';
var html = "<div modal-page>\n  <modal-close dismiss=\"$dismiss()\"></modal-close>\n  <div class=\"modal-header\">\n    <h3>Console Output: {{jobName}}</h3>\n  </div>\n  <form role=\"form\">\n    <div class=\"modal-body\">\n      <pre>{{logs}}</pre>\n    </div>\n    <div class=\"modal-footer\">\n      <button class=\"btn btn-primary\" ng-click=\"$close()\">Close</button>\n    </div>\n  </form>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/kubernetes/src/pipeline/stages/runJob/runJobLogs.html
// module id = 1501
// module chunks = 0